import { jsx as _jsx } from "react/jsx-runtime";
import { Navigate, useParams } from 'react-router-dom';
import { useFeatureFlag, useFeatureFlagsReady } from '../../../../contexts/featureFlagContext';
import { proposalHref } from '../../../../lib/proposalHref';
import { ProposalDocumentsPage } from './ProposalDocumentsPage';
/** `documents`: the hub when `proposal_documents_hub_v1` is on, otherwise today's Sources → Files. */ export function ProposalDocumentsRoute() {
    const { id } = useParams();
    const ready = useFeatureFlagsReady();
    const on = useFeatureFlag('proposal_documents_hub_v1') === true;
    if (!ready || !id) return null;
    return on ? /*#__PURE__*/ _jsx(ProposalDocumentsPage, {}) : /*#__PURE__*/ _jsx(Navigate, {
        to: proposalHref(id, 'sources/files'),
        replace: true
    });
}
